import {useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useState} from "react";
import {APIv1} from "../../../../../api";
import AnalyticsCard from "../BaseCard/AnalyticsCard";

const S2PFinancialCard = ({startPeriod, endPeriod, provider}) => {
    const {t} = useTranslation();
    const [userData, setUserData] = useState({});
    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            let url = (startPeriod && endPeriod) ? `/scan2pay/analysis/transactions/financial/?p=${provider}&start_period=${startPeriod}&end_period=${endPeriod}` : '/scan2pay/analysis/transactions/financial/payme/'
            const response = await APIv1.get(url, {
                headers: {
                    Authorization: `Token ${userData.token}`,
                },
            });
            const responseData = response.data;

            setData({
                avgIncome: responseData?.avg_income,
                successIncome: responseData?.success,
                failureIncome: responseData?.failure,
                tipsIncome: responseData?.tips,
            });

        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    }, [userData.token, startPeriod, endPeriod]);

    useEffect(() => {
        if (!userData.token) return;

        fetchData()
    }, [userData.token, startPeriod, endPeriod])


    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token, startPeriod, endPeriod]);

    return (
        <>
            <AnalyticsCard
                t={t}
                title={t("pages.scan2pay.analysis.title2")}
                avgIncome={data.avgIncome}
                success={data.successIncome}
                failure={data.failureIncome}
                tips={data.tipsIncome}
                isShowDate={false}
            />
        </>
    )
}

export default S2PFinancialCard;